export const SET_CAME_FROM_FULL_PATH = "SET_CAME_FROM_FULL_PATH";
